import Back from '../Back';
import styles from '../common/DevTools.module.scss';

const NoData = () => {
  return (
    <>
      <Back />

      <div className={styles.noData}>no data</div>
    </>
  );
};

export default NoData;
